import StepData from 'StepData';

class StepBucket {
    constructor(track, isTriplet=false) {
        this.track = track;
        this.isTriplet = isTriplet;

        // mapping from fraction of of 1/32th note to Step
        // so 0 -> would be the step that should be played at the
        // start of the step
        // 1/2 would be a step that shoud be played halfway through, (i.e.
        // 1/64th of a step after the beginning of that step
        this.steps = {}; //0: new StepData(undefined, undefined, undefined, track)};
    }

    getAllOnSteps(position) {
        let steps = [];
        if (position !== undefined) {
            if (this.steps[position]) {
                return this.steps[position].getPolyphony().filter(x => x.on);
            }
        }

        for (let position in this.steps) {
            steps = steps.concat(this.steps[position].getPolyphony()
                                 .filter(x => x.on));
        }

        return steps;
    }

    getAllOnStepsBefore(position) {
        let steps = [];
        for (let _position in this.steps) {
            if (parseFloat(_position) < position) {
                steps = [... steps,
                         ...this.steps[_position].getPolyphony().filter(x => x.on)
                        ];
            }
        }
        return steps;
    }

    getAnyOnStep() {
        for (let position in this.steps) {
            if (this.steps[position].on)  {
                return this.steps[position];
            }
        }

        return undefined;
    }
    
   getStep(i) {
        return this.steps[i] === undefined ?
            undefined :
            this.steps[i];
    }

    setStep(position, stepData, polyfill=false) {
        stepData.track = this.track;
        if (!this.isTriplet) {
            stepData.position = parseFloat(position);
        }

        if (polyfill &&
            this.steps[position] !== undefined &&
            this.steps[position].on &&
            this.steps[position].getPolyphony().length >= 1) {
            this.steps[position].addStep(stepData);
        } else {
            this.steps[position] = stepData;
        }
    }

    setStepAtPosition(step, position) {
        step.track = this.track;
        if (!this.isTriplet) {
            step.position = parseFloat(position);
        }
        this.steps[position] = step;
    }

    clear() {
        this.steps = {
            //0:  new StepData(undefined, undefined, undefined, this.track)
        };
    }

    getCopy(track=this.track) {
        var bucket = new StepBucket(track);
        bucket.isTriplet = bucket.isTriplet;
        let resolved = [];
        for (var key in this.steps) {
            if (!this.steps[key].on) {
                continue;
            }
            resolved.push(
                {key: key,
                 stepData: this.steps[key].getCopy(
                     false, false, true, true, false, true)});
        }
        for (let i in resolved) {
            bucket.setStep(resolved[i].key, resolved[i].stepData);
        }
        return bucket;
    }

    getJson() {
        var json = {};
        for (var key in this.steps) {
            json[key] = this.steps[key].getJson();
        }
        return json;
    }

    fromJson(json) {
        for (var key in json) {
            var stepData = this.steps[key] || new StepData();
            stepData.track = this.track;
            stepData.simpleLoad(
                json[key], this.effects, this.track, this.track.midiEffects.effects);
            this.steps[key] = stepData;
        }
    }

    anyOn() {
        for (var key in this.steps) {
            if (this.steps[key].getPolyphony().some(s => s.on)) {
                return true;
            }
        }
        return false;
    }

    anyEffectAutomation() {
        for (var key in this.steps) {
            if (this.steps[key].getPolyphony().some(
                step => !step.effectAutomations.isEmpty())) {
                return true;
            }
        }
        return false;
    }

    anyOnAfter(after, transpose, clearNull) {
        after = parseFloat(after);
        for (var key in this.steps) {
            let parseKey = parseFloat(key);
            if (parseKey + 0.00001 >= after &&
                this.steps[key].getPolyphony().some(
                    s => s.on &&
                        (transpose === undefined ||
                         (clearNull && s.transpose == null) ||
                         s.transpose === transpose))) {
                return true;
            }
        }
        return false;
    }

    clearAfterIfOn(after, transpose, clearNull) {
        let found = false;
        for (var key in this.steps) {
            if (key >= after &&
                this.steps[key].getPolyphony().some(
                    s => s.on && (transpose == undefined ||
                                  (clearNull && s.transpose == null) ||
                                  s.transpose == transpose))) {

                if (transpose !== undefined) {
                    // then see if transpose exists in polyhony
                    this.steps[key].deleteTranspose(transpose, clearNull);
                } else {
                    this.steps[key] = new StepData();
                }
                found = true;
            }
        }
        return found;
    }

    clearBeforeIfOn(before, transpose, clearNull) {
        let found = false;
        for (var key in this.steps) {
            if (key < before &&
                this.getStep(key).getPolyphony().some(
                    s => s.on && (transpose === undefined ||
                                  (clearNull && s.transpose == null) ||
                                  s.transpose == transpose))) {

                if (transpose !== undefined) {
                    // then see if transpose exists in polyhony
                    this.steps[key].deleteTranspose(transpose, clearNull);
                } else {
                    this.steps[key] = new StepData();
                }
                
                found = true;
            }
        }
        return found;
    }

}

export default StepBucket;
